module.exports = __webpack_public_path__ + "static/lor11-e126e35945c99bc98347a7a51c6cf7e8.jpg";